export default __webpack_public_path__ + "static/media/blue-info-icon.e931eb38.svg";